module.exports = __webpack_public_path__ + "static/pope-francis-83f2d147dc8a3bc6a99fc3d24f49670a.jpg";